module.exports = __webpack_public_path__ + "static/media/IOX API Documentation_ProductMO.4f495e3e.pdf";